import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import DataGrid from '../ui/DataGrid';
import DataCard from '../ui/DataCard';

/**
 * DashboardCoursesTab - Kurse Tab im Dashboard
 * 
 * Zeigt alle Kurse als Grid mit:
 * - Kurs-Info (Name, Beschreibung, Icon)
 * - Statistiken (Vorlagen, Sessions)
 * - Aktionen (Öffnen, Bearbeiten, Löschen)
 */
export default function DashboardCoursesTab({
  courses,
  templates,
  instances,
  onEdit,
  onDelete,
  onCreateCourse
}) {
  const navigate = useNavigate();

  // Get template count per course
  const getTemplateCount = (courseId) => {
    return templates.filter(t => t.courseId === courseId).length;
  };

  // Get active session count per course
  const getActiveSessionCount = (courseId) => {
    return instances.filter(i => i.courseId === courseId && i.isActive).length;
  };

  // Get total quizzes per course
  const getTotalQuizzes = (courseId) => {
    return instances.filter(i => i.courseId === courseId).length;
  };

  return (
    <DataGrid
      items={courses}
      columns={{ sm: 1, md: 2, lg: 2 }}
      gap="md"
      addCard={{
        label: 'Neuen Kurs erstellen',
        onClick: onCreateCourse
      }}
      emptyState={{
        title: 'Noch keine Kurse',
        description: 'Erstelle deinen ersten Kurs, um Vorlagen zu organisieren',
        action: { label: 'Kurs erstellen', onClick: onCreateCourse }
      }}
      renderItem={(course) => {
        const templateCount = getTemplateCount(course.id);
        const activeCount = getActiveSessionCount(course.id);
        const totalQuizzes = getTotalQuizzes(course.id);

        return (
          <DataCard
            key={course.id}
            icon={course.icon}
            color={course.color || '#3B82F6'}
            title={course.name}
            subtitle={course.description}
            stats={[
              { value: templateCount, label: 'Vorlagen' },
              { value: activeCount, label: 'Aktiv' },
              { value: totalQuizzes, label: 'Quizze' }
            ]}
            badges={activeCount > 0 ? [{ label: `${activeCount} Live`, variant: 'success' }] : []}
            primaryAction={{
              label: 'Öffnen',
              onClick: () => navigate(`/course/${course.id}`)
            }}
            menuActions={[
              { label: 'Bearbeiten', onClick: () => onEdit(course) },
              { label: 'Duplizieren', onClick: () => alert('Duplizieren wird noch implementiert') },
              { label: 'Archivieren', onClick: () => alert('Archivieren wird noch implementiert'), variant: 'warning' },
              { label: 'Löschen', onClick: () => onDelete(course), variant: 'danger' }
            ]}
            onClick={() => navigate(`/course/${course.id}`)}
          />
        );
      }}
    />
  );
}

DashboardCoursesTab.propTypes = {
  courses: PropTypes.array.isRequired,
  templates: PropTypes.array.isRequired,
  instances: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onCreateCourse: PropTypes.func.isRequired
};
